type DebouncedFunction<T extends (...args: any[]) => any> = {
  (...args: Parameters<T>): void;
  cancel: () => void;
};

/**
 * Расширенная реализация debounce с возможностью отмены
 * @param func - Функция для вызова
 * @param wait - Время задержки в мс
 * @param immediate - Вызвать сразу при первом вызове
 * @returns Дебаунсированная функция с методом cancel
 */
export function debounce<T extends(...args: any[]) => any>(
  func: T,
  wait: number,
  immediate = false,
): DebouncedFunction<T> {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;

  const debounced = function (...args: Parameters<T>) {
    const later = () => {
      timeoutId = null;
      if (!immediate) func(...args);
    };

    const callNow = immediate && !timeoutId;

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(later, wait);

    if (callNow) {
      func(...args);
    }
  };

  debounced.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  return debounced;
}
